import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase-client';

function call(name) {
  return httpsCallable(functions, name);
}

export async function createBoardTopic(payload) {
  const fn = call('createBoardTopic');
  const result = await fn(payload);
  return result.data;
}

export async function updateBoardTopic(payload) {
  const fn = call('updateBoardTopic');
  const result = await fn(payload);
  return result.data;
}

export async function createBoardReply(payload) {
  const fn = call('createBoardReply');
  const result = await fn(payload);
  return result.data;
}

export async function updateBoardReply(payload) {
  const fn = call('updateBoardReply');
  const result = await fn(payload);
  return result.data;
}

export async function toggleBoardContentReaction(payload) {
  const fn = call('toggleBoardContentReaction');
  const result = await fn(payload);
  return result.data;
}

export async function deleteMyBoardContent(payload) {
  const fn = call('deleteMyBoardContent');
  const result = await fn(payload);
  return result.data;
}

export async function ensureBoardModerationCase(payload) {
  const fn = call('ensureBoardModerationCase');
  const result = await fn(payload);
  return result.data;
}

export async function reportBoardContent(payload) {
  const fn = call('reportBoardContent');
  const result = await fn(payload);
  return result.data;
}

export async function reviewBoardModerationCase(payload) {
  const fn = call('reviewBoardModerationCase');
  const result = await fn(payload);
  return result.data;
}

export async function deleteBoard(payload) {
  const fn = call('deleteBoard');
  const result = await fn(payload);
  return result.data;
}

export async function setBoardTopicPinned(payload) {
  const fn = call('setBoardTopicPinned');
  const result = await fn(payload);
  return result.data;
}

export async function searchBoardMentionTargets(payload) {
  const fn = call('searchBoardMentionTargets');
  const result = await fn(payload);
  return result.data;
}

export async function openBoardModerationAdminThread(payload) {
  const fn = call('openBoardModerationAdminThread');
  const result = await fn(payload);
  return result.data;
}

export async function listAccessibleBoards(payload) {
  const fn = call('listAccessibleBoards');
  const result = await fn(payload);
  return result.data;
}

export async function searchBoardModerationCases(payload) {
  const fn = call('searchBoardModerationCases');
  const result = await fn(payload);
  return result.data;
}

export async function getBoardModerationEvidence(payload) {
  const fn = call('getBoardModerationEvidence');
  const result = await fn(payload);
  return result.data;
}

export async function listVisibleTeamEvents(payload) {
  const fn = call('listVisibleTeamEvents');
  const result = await fn(payload);
  return result.data;
}

export async function listVisibleEventCommentTopics(payload) {
  const fn = call('listVisibleEventCommentTopics');
  const result = await fn(payload);
  return result.data;
}

export async function setEventCommentsEnabled(payload) {
  const fn = call('setEventCommentsEnabled');
  const result = await fn(payload);
  return result.data;
}

export async function setEventRsvpSeriesResponsesEnabled(payload) {
  const fn = call('setEventRsvpSeriesResponsesEnabled');
  const result = await fn(payload);
  return result.data;
}

export async function createEventComment(payload) {
  const fn = call('createEventComment');
  const result = await fn(payload);
  return result.data;
}

export async function getEventCommentThread(payload) {
  const fn = call('getEventCommentThread');
  const result = await fn(payload);
  return result.data;
}
